import useJwt from '@core/auth/jwt/useJwt'
import axios from '@axios'

const { jwt } = useJwt(axios, {})
// Register after construction to keep the HTTP client independent of JWT initialization.
axios.setUnauthorizedHandler(() => jwt.logout())
export default jwt
